// extracted by mini-css-extract-plugin
export default {"filters":"BtnsFilters_filters__50lR7","selected":"BtnsFilters_selected__DUams"};